<template>
  <div>
    <Table
      resource="BannerV2"
      :actions="actions"
      :table-actions="tableActions"
      :items="$store.getters['bannerV2/tableData']"
      :detail="$store.getters['bannerV2/detailData']"
      :detail-route="row => `/v2/banners/${row.id}/detail`"
      :fields="$store.getters['bannerV2/tableFields']"
      :pagination="$store.state.bannerV2.tablePagination"
      :keyword="$store.state.bannerV2.tableKeyword"
      :loading="$store.state.bannerV2.loadingTable"
      :filter="$store.state.bannerV2.tableFilter"
      :sort="$store.state.bannerV2.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: { Table },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at',
          direction: 'desc',
          label: 'Terbaru',
          default: true,
        },
        {
          key: 'created_at',
          direction: 'asc',
          label: 'Terlama',
        },
        {
          key: 'order',
          direction: 'asc',
          label: 'Urutan',
        },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  computed: {
    tableActions() {
      const actions = []
      if (this.$can('manage', 'BannerV2')) {
        actions.push({
          label: 'Urutan Banner',
          event: () => this.$router.push({ name: 'banners-sort' }),
        })
      }
      return actions
    },
  },
  methods: {
    loadData() {
      return this.$store.dispatch('bannerV2/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('bannerV2/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('bannerV2/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('bannerV2/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('bannerV2/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('bannerV2/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('bannerV2/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('bannerV2/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('bannerV2/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('bannerV2/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
